module.exports = __webpack_public_path__ + "static/img/18.5bdf966.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clientes/18.png
// module id = wDtq
// module chunks = 0